// extracted by mini-css-extract-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_NV7","cls2":"ChurnedUserReactivationButton-cls2_Slo ChurnedUserReactivationButton-cls1_NV7"};